import { Component, Input, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef } from "ngx-bootstrap/modal/modal-options.class";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import * as fromRootStore from "../../../reducers";

//import { CategoryService } from '../../services/index';

@Component({
  selector: "modal-content",
  templateUrl: "./addEditSalesplan.component.html",
})
export class AddEditSalesPlanReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Input() agentdata: any = [];
  @Input() _params: any;

  finyearCtrl: FormControl = new FormControl();
  finyear: any;
  isLoadMask: Promise<any>;
  finyearList: any[];
  loadingIndicator: boolean = true;
  mode: any;

  isLoading: boolean = false;

  planData: any;

  data: any;

  constructor(
    public store: Store<fromRootStore.State>,
    public bsModalRef: BsModalRef,
    public toasterService: ToasterService
  ) {
    // this.companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
  }

  ngOnInit() {
    this.data = {
      sp_id: 0,
      fin_id: 0,
      finyear: "",
      sales_target: 0,
      actual_order: 0,
      diff: 0,
      seasons: [],
      agents: [],
      list: [],
      plan_details: [],
    };
    this.initData();
  }
  initData() {
    this.data = {
      sp_id: 0,
      fin_id: 0,
      finyear: "2015-2016",
      sales_target: 20000,
      actual_order: 10000,
      diff: 10000,
      seasons: [
        {
          season_id: 1,
          season_name: "Summer",
          actual_order: 2000,
        },
        {
          season_id: 2,
          season_name: "Deewali",
          actual_order: 2000,
        },
      ],
      party: [
        {
          party_id: 1,
          name: "aaa",
          sales_target: 3000,
          actual_order: 1000,
          diff: 2000,
          seasons: [
            {
              season_id: 1,
              season_name: "Summer",
              actual_order: 500,
            },
            {
              season_id: 2,
              season_name: "Deewali",
              actual_order: 1500,
            },
          ],
        },
        {
          party_id: 2,
          name: "bbb",
          actual_order: 300,
          seasons: [
            {
              season_id: 1,
              season_name: "Summer",
              actual_order: 300,
            },
            {
              season_id: 2,
              season_name: "Deewali",
              actual_order: 500,
            },
          ],
        },
      ],
      list: [],
      plan_details: [],
    };
    //   this.process();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#categoryname").focus();
    }, 100);
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/salesplanreport/addEditSalesplan.component.ts